<section class="login-page" aria-labelledby="login-title">
  <div class="login-card">
    <img src="assets/brand-minambiente.png" alt="Ambiente - Ministerio de Ambiente y Desarrollo Sostenible" />
    <p class="eyebrow">HU-001 · Autenticación</p>
    <h1 id="login-title">Iniciar sesión</h1>
    <p>Para acceder al Sistema de Registro PSA y otros incentivos a la conservación será redirigido al servicio institucional de Autenticación Digital.</p>
    <button type="button" class="btn-govco" (click)="login()">Continuar con Autenticación Digital</button>
    @if (auth.loginError()) { <p role="alert">{{ auth.loginError() }}</p> }
    @else if (unavailable) { <p role="alert">El servicio de autenticación no está disponible. Intente nuevamente.</p> }
    @else if (failed) { <p role="alert">No fue posible iniciar sesión. Intente nuevamente.</p> }
    @if (expired) { <p role="status">Su sesión expiró. Inicie sesión nuevamente.</p> }
    <p class="login-register">¿Aún no tiene registro? <a routerLink="/registro-inicial">Regístrese como usuario</a></p>
    <a routerLink="/inicio" class="login-back">Volver a la portada</a>
  </div>
</section>
